import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { buildWebPage } from "../components/schema";
import { PageHeader } from "../components/PageHeader";
import { Services } from "../components/Services";

export default function ServiziPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="servizi-page">
      <Seo
        title="Vetrate panoramiche VEPA senza profili | Progettazione e installazione"
        description="Sistemi VEPA in vetro temperato e stratificato: scorrimento e impacchettamento, soluzioni indoor & outdoor. Progettazione e installazione di vetrate panoramiche senza profili nelle Marche."
        path="/vetrate-panoramiche-vepa"
        jsonLd={buildWebPage("Vetrate panoramiche VEPA", "/vetrate-panoramiche-vepa", "Sistemi VEPA in vetro temperato e stratificato: scorrimento e impacchettamento, soluzioni indoor & outdoor nelle Marche.", "Vetrate Panoramiche VEPA")}
      />
      <Navbar />
      <PageHeader
        eyebrow="Vetrate Panoramiche"
        h1="Sistemi VEPA in vetro per terrazzi, balconi e dehor"
        intro="Vetrate panoramiche VEPA frameless, completamente in vetro temperato e stratificato di sicurezza, senza montanti verticali. Sistemi a scorrimento e a impacchettamento totale per ambienti indoor & outdoor: progettazione su misura e installazione professionale in tutte le Marche."
      />
      <Services />
      <Footer />
    </div>
  );
}
